/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2022-2024 (original work) Open Assessment Technologies SA ;
 */

/**
 * Returns list of integers
 *
 * @param {int} size - amount of integers.
 * @param {int} [offset=0] - value of the first integer.
 * @param {int} [step=1] - distance between two values.
 *
 * @returns {int[]}
 */
export const range = (size, offset = 0, step = 1) => {
    const keys = [...Array(size).keys()];

    return keys.map(k => k * step + offset);
};

/**
 * Convert number to percentage
 * @param {number} number - Number from 0 to 1
 * @returns {number}
 */
export const percentage = number => Math.ceil(number * 100);
